import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export default function PublicMotion({ rootRef, routeKey }) {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    let intersection, mutation, scanFrame;
    const owned = new Set();
    const selector = '.portal-section-top, .portal-service, .portal-content-intro, .portal-blocks > div > section, .portal-blocks a.group, .portal-article-header, .portal-article-cover, .portal-article-summary, .enews-article-content > *, .portal-related, .portal-category-header';
    const scan = () => {
      root.querySelectorAll(selector).forEach(element => {
        if (owned.has(element) || element.closest('.portal-hero') || element.parentElement.closest('.portal-reveal')) return;
        owned.add(element);
        element.classList.add('portal-reveal');
        const siblings = Array.from(element.parentElement.children);
        element.style.setProperty('--reveal-delay', `${Math.min(siblings.indexOf(element), 3) * 75}ms`);
        intersection.observe(element);
      });
    };
    const disable = () => {
      intersection?.disconnect(); mutation?.disconnect(); cancelAnimationFrame(scanFrame);
      owned.forEach(element => { element.classList.remove('portal-reveal', 'is-visible'); element.style.removeProperty('--reveal-delay'); });
      owned.clear();
    };
    const setup = () => {
      disable();
      if (preference.matches || !('IntersectionObserver' in window)) return;
      intersection = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); intersection.unobserve(entry.target); }
      }), { threshold: 0, rootMargin: '0px 0px -24px 0px' });
      scan();
      mutation = new MutationObserver(() => { cancelAnimationFrame(scanFrame); scanFrame = requestAnimationFrame(scan); });
      mutation.observe(root, { childList: true, subtree: true });
    };
    setup(); preference.addEventListener('change', setup);
    return () => { disable(); preference.removeEventListener('change', setup); };
  }, [rootRef, routeKey]);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      setShowTop(window.scrollY > 650);
      const article = rootRef.current?.querySelector('.portal-article');
      const bar = rootRef.current?.querySelector('.portal-reading-progress');
      if (!bar) return;
      const rect = article?.getBoundingClientRect();
      const progress = rect ? Math.min(1, Math.max(0, (120 - rect.top) / Math.max(1, rect.height - innerHeight + 120))) : 0;
      bar.style.transform = `scaleX(${progress})`;
      bar.parentElement.hidden = !article;
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(update); };
    update(); window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
    const mutation = new MutationObserver(onScroll);
    if (rootRef.current) mutation.observe(rootRef.current, { childList: true, subtree: true });
    return () => { cancelAnimationFrame(frame); mutation.disconnect(); window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); };
  }, [rootRef, routeKey]);
  return <>
    <div className="portal-reading-track" hidden aria-hidden="true"><div className="portal-reading-progress" /></div>
    {showTop && <button className="portal-back-top" aria-label="Về đầu trang" onClick={() => window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })}><ArrowUp size={19} /></button>}
  </>;
}
